import { createSelector } from 'reselect';

import { store } from '../../core/state';
import { GetRestaurantProps } from '../../core/state/store/store.types.d';

/**
 * Gets available payments combining user and restaurant config
 */
export const getAvailablePayments = createSelector(
  [
    (state: WebOrder.State) => state.payments.items,
    (state: WebOrder.State, props: GetRestaurantProps) =>
      store.selectors.getRestaurantDetails(state, props),
  ],
  (items, restaurant) => {
    if (!restaurant) {
      return [];
    }

    const { AcceptCardOrders, AcceptCashOrders } = restaurant;

    return Object.values(items)
      .filter((p) => p.status !== 'error' && p.status !== 'none')
      .filter((p) =>
        AcceptCashOrders ? true : p.PaymentAccountType !== 'CashPaymentAccount',
      )
      .filter((p) =>
        AcceptCardOrders ? true : p.PaymentAccountType !== 'CardPaymentAccount',
      )
      .sort((a, b) => a.displayOrder - b.displayOrder);
  },
);
